const addons = {
  // صفحة المتجر
  pageTitle: 'الإضافات',
  pageSubtitle: 'عزّز إعلاناتك بإضافات وخدمات مميزة',
  myAddonsTitle: 'إضافاتي',
  myAddonsEmpty: 'لم تقم بشراء أي إضافات بعد.',
  catalogEmpty: 'لا توجد إضافات متاحة حالياً. يرجى المحاولة لاحقاً.',
  signInToBuy: 'سجّل الدخول لشراء الإضافات',
  loadError: 'تعذّر تحميل الإضافات',

  // العائلات
  family: {
    VISIBILITY_LIFECYCLE: 'الظهور ودورة الإعلان',
    LISTING_ENRICHMENT: 'إثراء الإعلان',
    AI_STUDIO: 'استوديو الذكاء الاصطناعي',
    TRUST_VERIFICATION: 'الثقة والتوثيق',
    PROFESSIONAL_CONTENT: 'المحتوى الاحترافي',
    PERSONAL: 'شخصي',
    OTHER: 'أخرى',
  },

  // الفئات المستهدفة
  audience: {
    OWNER: 'المالك',
    BROKER: 'الوسيط',
    COMPANY: 'الشركة',
    ALL: 'الجميع',
  },

  // طريقة التنفيذ
  fulfillment: {
    AUTO: 'فوري',
    MANUAL_ORDER: 'طلب يدوي',
  },

  // حالات الشراء
  status: {
    PENDING_PAYMENT: 'بانتظار الدفع',
    PENDING_FULFILLMENT: 'بانتظار التنفيذ',
    ACTIVE: 'نشط',
    FULFILLED: 'تم التنفيذ',
    EXPIRED: 'منتهي',
    CANCELLED: 'ملغي',
    REFUNDED: 'مُسترَد',
  },

  // التسعير
  priceSar: '{{price}} ريال',
  quoteBased: 'اطلب عرض سعر',
  free: 'مجاني',
  coinPrice: '{{count}} نقطة',
  yourBalance: 'رصيدك',
  planDiscountNote: 'باقتك: خصم {{percent}}% على كل الإضافات',

  // الأزرار
  buy: 'شراء',
  payWithCoins: 'الدفع بالنقاط',
  request: 'طلب',
  pay: 'ادفع الآن',
  cancel: 'إلغاء',
  fulfilled: 'تحديد كمُنفّذ',
  setPrice: 'تحديد السعر',
  processing: 'جارٍ المعالجة...',

  // التنبيهات
  purchaseSuccess: 'تم شراء الإضافة وتفعيلها بنجاح',
  payWithCoinsSuccess: 'تم تفعيل الإضافة وخصم النقاط من رصيدك.',
  insufficientCoins: 'رصيد النقاط غير كافٍ. يرجى شحن رصيدك والمحاولة مرة أخرى.',
  requestReceived: 'تم استلام طلبك. سنتواصل معك قريباً.',
  paySuccess: 'تم الدفع بنجاح. الإضافة الآن نشطة.',
  cancelSuccess: 'تم إلغاء عملية شراء الإضافة',
  actionError: 'حدث خطأ ما. يرجى المحاولة مرة أخرى.',

  // تأكيد الشراء غير القابل للاسترداد (يظهر قبل كل عملية دفع)
  confirm: {
    title: 'تأكيد الشراء',
    message: 'عملية الشراء نهائية ولا يمكن استردادها بعد التفعيل. هل تريد المتابعة؟',
    coinsMessage: 'سيتم خصم {{count}} عملة من رصيدك وهي غير قابلة للاسترداد. هل تريد المتابعة؟',
    cta: 'تأكيد الشراء',
  },

  // صفحة إضافاتي (استخدام/تفعيل ما تملكه)
  myAddons: {
    pageTitle: 'إضافاتي',
    pageSubtitle: 'استخدم الإضافات التي تملكها - طبّق إضافات العقارات على إعلان، أو اطّلع على خدماتك الشخصية الفعّالة.',
    empty: 'لم تقم بشراء أي إضافات بعد.',
    browse: 'تصفّح الإضافات',
    readyToUse: 'جاهزة للاستخدام',
    useCta: 'استخدام',
    accountActive: 'فعّالة على حسابك',
    appliedTo: 'مُطبّقة على {{name}}',
    fromBundle: 'من حزمة',
    standalone: 'إضافات فردية',
    pickPropertyTitle: 'اختر إعلاناً',
    pickPropertySubtitle: 'اختر الإعلان الذي تريد تطبيق هذه الإضافة عليه.',
    noApplicableProperties: 'لا توجد لديك إعلانات لتطبيق الإضافة عليها بعد.',
    createListing: 'أنشئ إعلاناً',
    applySuccess: 'تم تطبيق الإضافة على إعلانك.',
    applyError: 'تعذّر تطبيق الإضافة. يرجى المحاولة مرة أخرى.',
    loadError: 'تعذّر تحميل إضافاتك.',
  },

  // لوحة الإدارة: الكتالوج
  admin: {
    catalogTitle: 'الإضافات',
    catalogSubtitle: 'إدارة كتالوج الإضافات',
    ordersTitle: 'طلبات الإضافات',
    ordersSubtitle: 'تنفيذ وإدارة عمليات شراء الإضافات',
    addAddon: 'إضافة جديدة',
    editAddon: 'تعديل الإضافة',
    createAddon: 'إنشاء إضافة',
    deleteConfirm: 'هل أنت متأكد من حذف "{{name}}"؟ إذا كانت عليها عمليات شراء فسيتم تعطيلها بدلاً من حذفها.',
    emptyCatalog: 'لا توجد إضافات بعد. أنشئ واحدة للبدء.',
    emptyOrders: 'لا توجد طلبات إضافات.',
    allFamilies: 'كل العائلات',
    allStatuses: 'كل الحالات',
    allFulfillment: 'كل طرق التنفيذ',

    // عناوين الحقول
    fieldSlug: 'المعرّف (Slug)',
    fieldSlugHint: 'معرّف فريد. لا يمكن تغييره لاحقاً.',
    fieldName: 'الاسم (إنجليزي)',
    fieldNameAr: 'الاسم (عربي)',
    fieldDescription: 'الوصف (إنجليزي)',
    fieldDescriptionAr: 'الوصف (عربي)',
    fieldFamily: 'العائلة',
    fieldFulfillment: 'طريقة التنفيذ',
    fieldAudiences: 'الفئات المستهدفة',
    fieldPriceSar: 'السعر (ريال)',
    fieldPriceSarHint: 'اتركه فارغاً للإضافات المعتمدة على عرض السعر.',
    fieldPriceCoins: 'السعر (نقاط)',
    fieldQuoteBased: 'حسب الطلب (السعر عند الطلب)',
    fieldDurationDays: 'المدة (أيام)',
    fieldActive: 'نشط (ظاهر في المتجر)',
    fieldSortOrder: 'ترتيب العرض',
    fieldMetadata: 'بيانات إضافية (JSON)',
    metadataInvalid: 'يجب أن تكون البيانات الإضافية بصيغة JSON صحيحة',
    audiencesRequired: 'اختر فئة مستهدفة واحدة على الأقل',

    // أعمدة الجدول
    colName: 'الاسم',
    colFamily: 'العائلة',
    colAudiences: 'الفئات',
    colFulfillment: 'التنفيذ',
    colPrice: 'السعر',
    colStatus: 'الحالة',
    colActions: 'الإجراءات',
    colBuyer: 'المشتري',
    colAddon: 'الإضافة',
    colCreated: 'تاريخ الإنشاء',
    colActive: 'نشط',
    colInactive: 'غير نشط',

    // إجراءات الطلب
    setPriceTitle: 'تحديد سعر العرض',
    setPriceLabel: 'السعر (ريال)',
    orderNotes: 'ملاحظات (اختياري)',
    markFulfilled: 'تحديد كمُنفّذ',
    cancelOrder: 'إلغاء الطلب',
    save: 'حفظ',
    saving: 'جارٍ الحفظ...',
    saveError: 'تعذّر حفظ التغييرات',
    createError: 'تعذّر إنشاء الإضافة',
    updateError: 'تعذّر تحديث الإضافة',
    deleteError: 'تعذّر حذف الإضافة',
  },
};

export default addons;
